/* Saleha Art: "See it on your wall" (sections/sa-wall-preview.liquid).
   The customer's photo never leaves their device: it is read with a local blob URL and drawn on a canvas only when they save. */
(function () {
  var SIZES = [
    { k: 'XS', w: 8, h: 12 }, { k: 'S', w: 11, h: 14 }, { k: 'R', w: 12, h: 16 }, { k: 'M', w: 16, h: 20 },
    { k: 'L', w: 20, h: 30 }, { k: 'XL', w: 24, h: 36 }, { k: 'XXL', w: 30, h: 40 }, { k: 'XXXL', w: 40, h: 60 }
  ];
  var LAYOUTS = [
    { k: 'single', label: 'Statement piece', n: 1, cols: 1, size: 'XL' },
    { k: 'pair', label: 'Pair side by side', n: 2, cols: 2, size: 'L' },
    { k: 'trio', label: 'Row of three', n: 3, cols: 3, size: 'M' },
    { k: 'grid', label: 'Gallery of four', n: 4, cols: 2, size: 'M' }
  ];
  var FRAMES = { canvas: null, black: '#1d1b19', white: '#f4f2ee', wood: '#a27a4f', gold: '#b8995a', silver: '#c0c3c6' };
  var GAP = 3; /* inches between pieces */
  var MOBILE_LIST = 12; /* paintings shown on phones before "Show more" */
  var CSS = [
    '.sa-wpa{display:grid;grid-template-columns:minmax(0,1fr);gap:22px;align-items:start}',
    '@media(min-width:960px){.sa-wpa{grid-template-columns:minmax(0,1.55fr) minmax(300px,1fr);gap:32px}}',
    '.sa-wpa__stage{position:relative;background:#f6f5f1;border-radius:14px;overflow:hidden;min-height:320px;display:flex;align-items:center;justify-content:center;touch-action:pan-y;user-select:none;-webkit-user-select:none}',
    '.sa-wpa__room{display:block;width:100%;height:auto;max-height:78vh;object-fit:contain}',
    '.sa-wpa__empty{padding:36px 22px;text-align:center;max-width:420px}',
    '.sa-wpa__empty .btn{margin:4px}',
    '.sa-wpa__privacy{display:block;margin-top:12px;font-size:12px;opacity:.6}',
    '.sa-wpa__layer{position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none}',
    '.sa-wpa__group{position:absolute;pointer-events:auto;cursor:grab;touch-action:none}',
    '.sa-wpa__group:active{cursor:grabbing}',
    '.sa-wpa__piece{position:absolute;box-sizing:border-box;box-shadow:3px 6px 14px rgba(0,0,0,.28);background:#ddd;overflow:hidden}',
    '.sa-wpa__piece.is-canvas{box-shadow:4px 8px 16px rgba(0,0,0,.32),inset -2px -2px 4px rgba(0,0,0,.18)}',
    '.sa-wpa__piece.is-active{outline:2px dashed #fff;outline-offset:3px}',
    '.sa-wpa__piece .m{position:absolute;background:#fff}',
    '.sa-wpa__piece img{position:absolute;width:100%;height:100%;object-fit:cover;display:block}',
    '.sa-wpa__piece .ph{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:11px;text-align:center;color:#555;background:repeating-linear-gradient(45deg,#eee,#eee 6px,#e4e1db 6px,#e4e1db 12px);padding:4px}',
    '.sa-wpa__ruler{position:absolute;height:0;border-top:2px solid #e05a2b;pointer-events:none}',
    '.sa-wpa__dot{position:absolute;width:26px;height:26px;margin:-13px 0 0 -13px;border-radius:50%;background:#e05a2b;border:3px solid #fff;box-shadow:0 1px 6px rgba(0,0,0,.35);pointer-events:auto;cursor:ew-resize;touch-action:none}',
    '.sa-wpa__rlabel{position:absolute;transform:translate(-50%,-130%);padding:3px 8px;border-radius:999px;background:#e05a2b;color:#fff;font-size:12px;white-space:nowrap;pointer-events:none}',
    '.sa-wpa__tip{position:absolute;left:10px;top:10px;right:10px;padding:10px 14px;border-radius:10px;background:rgba(255,255,255,.94);font-size:15px;line-height:1.4;pointer-events:none;text-align:center}',
    '.sa-wpa__tip b{color:#e05a2b}',
    '.sa-wpa__panel{display:grid;gap:18px}',
    '.sa-wpa__step{background:#f6f5f1;border-radius:12px;padding:16px 18px}',
    '.sa-wpa__sh{display:flex;align-items:flex-start;gap:10px;margin:0 0 12px}',
    '.sa-wpa__sh span{flex:0 0 26px;height:26px;border-radius:50%;background:#5c4a3a;color:#fff;font-size:13px;display:flex;align-items:center;justify-content:center;margin-top:1px}',
    '.sa-wpa__sh h3{margin:0;font-size:18px;line-height:1.35;letter-spacing:0;text-transform:none}',
    '.sa-wpa__help{margin:10px 0 0;font-size:13px;line-height:1.5;opacity:.7}',
    '.sa-wpa__label{margin:0 0 8px;font-size:13px;opacity:.75}',
    '.sa-wpa__other{margin-top:10px;font-size:14px}',
    '.sa-wpa__link{font:inherit;font-size:13px;background:none;border:0;padding:0;margin-top:10px;text-decoration:underline;color:inherit;cursor:pointer;opacity:.8}',
    '.sa-wpa__up{font-size:15px;padding:16px 26px}',
    '.sa-wpa__tipline{margin:16px auto 0;font-size:14px;line-height:1.5;opacity:.8;max-width:320px}',
    '.sa-wpa__empty .sa-wpa__link{display:block;margin:12px auto 0}',
    '.sa-wpa__row{display:flex;flex-wrap:wrap;gap:6px;align-items:center}',
    '.sa-wpa__chip{font:inherit;font-size:13px;line-height:1;padding:9px 12px;border:1px solid rgba(0,0,0,.18);border-radius:999px;background:#fff;color:inherit;cursor:pointer}',
    '.sa-wpa__chip small{display:block;font-size:10.5px;opacity:.65;margin-top:3px}',
    '.sa-wpa__chip.is-on{background:#2b2926;border-color:#2b2926;color:#fff}',
    '.sa-wpa__chip[disabled]{opacity:.35;cursor:default}',
    '.sa-wpa__num{width:84px;font:inherit;font-size:14px;padding:8px 10px;border:1px solid rgba(0,0,0,.2);border-radius:8px;background:#fff}',
    '.sa-wpa__sel{font:inherit;font-size:14px;padding:8px 10px;border:1px solid rgba(0,0,0,.2);border-radius:8px;background:#fff}',
    '.sa-wpa__sw{width:26px;height:26px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.25);cursor:pointer;padding:0}',
    '.sa-wpa__sw.is-on{box-shadow:0 0 0 2px #2b2926}',
    '.sa-wpa__search{width:100%;font:inherit;font-size:14px;padding:9px 12px;border:1px solid rgba(0,0,0,.2);border-radius:999px;background:#fff;margin-bottom:10px;box-sizing:border-box}',
    '.sa-wpa__list{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;max-height:420px;overflow-y:auto;padding:2px;-webkit-overflow-scrolling:touch}',
    '.sa-wpa__art{display:block;-webkit-appearance:none;appearance:none;width:100%;height:auto;min-height:0;margin:0;border:2px solid transparent;border-radius:10px;padding:4px;background:#fff;cursor:pointer;color:inherit;font:inherit;text-align:center}',
    '.sa-wpa__art .t{display:block;position:relative;width:100%;height:0;padding-top:100%;overflow:hidden;border-radius:6px;background:#fff}',
    '.sa-wpa__art .t img{position:absolute!important;left:0!important;top:0!important;width:100%!important;height:100%!important;max-width:none!important;object-fit:contain!important;display:block;margin:0!important}',
    '.sa-wpa__art .n{display:block;margin-top:4px;font-size:11px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.sa-wpa__art.is-on{border-color:#2b2926}',
    '.sa-wpa__more{grid-column:1/-1;font:inherit;font-size:13px;padding:11px 14px;margin-top:2px;border:1px solid rgba(0,0,0,.2);border-radius:999px;background:#fff;color:inherit;cursor:pointer}',
    '.sa-wpa__slots{display:flex;gap:6px;margin-bottom:10px;flex-wrap:wrap}',
    '.sa-wpa__actions{display:flex;flex-wrap:wrap;gap:10px}',
    '.sa-wpa__actions .btn{flex:1 1 auto;text-align:center}',
    '.sa-wpa__shop{margin:10px 0 0;padding:0;list-style:none;font-size:13px;line-height:1.6}',
    '.sa-wpa__shop a{color:inherit}',
    '.sa-wpa__note{font-size:12px;opacity:.65;margin:8px 0 0}',
    '.sa-wpa__fit{margin:12px 0 0;font-size:14px}',
    '.sa-wpa__opt{border:1px solid rgba(0,0,0,.12);border-radius:12px;padding:0 18px}',
    '.sa-wpa__opt summary{cursor:pointer;list-style:none;padding:14px 0;font-size:14px}',
    '.sa-wpa__opt summary::-webkit-details-marker{display:none}',
    '.sa-wpa__optin{padding:0 0 16px}',
    '.sa-wpa__optin .sa-wpa__label{margin:12px 0 8px}',
    '.sa-wpa__stage.has-room{position:sticky;top:var(--sa-wp-top,16px);z-index:3;box-shadow:0 6px 18px rgba(0,0,0,.08)}',
    '@media(max-width:959px){.sa-wpa__list{max-height:none;overflow:visible}.sa-wpa__room{max-height:36vh}.sa-wpa__stage.has-room{min-height:0}.sa-wpa__tip{left:8px;right:8px;top:8px;padding:6px 10px;font-size:13px}}'
  ].join('');

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function local(u) { return String(u || '').replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '/cdn/shop/').replace(/^(https?:)?\/\/[^\/]+(?=\/cdn\/shop\/)/, ''); }
  function sized(u, w) { u = local(u); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function load(src) { return new Promise(function (ok, no) { var i = new Image(); i.onload = function () { ok(i); }; i.onerror = no; i.src = src; }); }
  function isPhone() { return window.innerWidth < 960; }
  /* Find the painting inside a framed mockup photo (same idea as assets/sa-mockups.js). */
  function findArt(img) {
    try {
      var W = 300, H = Math.round(W * img.naturalHeight / img.naturalWidth), cv = document.createElement('canvas');
      cv.width = W; cv.height = H; var g = cv.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, W, H); g.drawImage(img, 0, 0, W, H);
      var d = g.getImageData(0, 0, W, H).data;
      var P = function (x, y) { var i = (y * W + x) * 4; return [d[i], d[i + 1], d[i + 2]]; };
      var L = function (p) { return (p[0] + p[1] + p[2]) / 3; };
      var S = function (p) { return Math.max(p[0], p[1], p[2]) - Math.min(p[0], p[1], p[2]); };
      var scan = function (get, n) {
        var k = 0, lim = n * .45, run = 0, start;
        while (k < lim && L(get(k)) >= 130) k++;
        if (k >= lim) return -1;
        while (k < lim && L(get(k)) < 150) k++;
        start = k;
        while (k < lim) { var p = get(k); if (S(p) < 14 && L(p) > 135) { run = 0; start = k + 1; } else { run++; if (run >= 3) break; } k++; }
        return k >= lim ? -1 : start;
      };
      var med = function (a) { a = a.filter(function (v) { return v >= 0; }).sort(function (x, y) { return x - y; }); return a.length ? a[Math.floor(a.length / 2)] : -1; };
      var fr = [.3, .4, .5, .6, .7];
      var l = med(fr.map(function (f) { return scan(function (k) { return P(k, Math.round(H * f)); }, W); }));
      var r = med(fr.map(function (f) { return scan(function (k) { return P(W - 1 - k, Math.round(H * f)); }, W); }));
      var t = med(fr.map(function (f) { return scan(function (k) { return P(Math.round(W * f), k); }, H); }));
      var b = med(fr.map(function (f) { return scan(function (k) { return P(Math.round(W * f), H - 1 - k); }, H); }));
      if (l < 0 || r < 0 || t < 0 || b < 0) return null;
      var x0 = l, x1 = W - 1 - r, y0 = t, y1 = H - 1 - b;
      if (x1 - x0 < W * .3 || y1 - y0 < H * .3) return null;
      var ix = (x1 - x0) * .01, iy = (y1 - y0) * .01;
      return { x: (x0 + ix) / W, y: (y0 + iy) / H, w: (x1 - x0 - 2 * ix) / W, h: (y1 - y0 - 2 * iy) / H };
    } catch (e) { return null; }
  }
  function artFrom(img, max) { /* returns { url, ratio } with only the painting */
    var b = findArt(img) || { x: 0, y: 0, w: 1, h: 1 };
    var sw = b.w * img.naturalWidth, sh = b.h * img.naturalHeight;
    var sc = Math.min(1, (max || 900) / Math.max(sw, sh)), cv = document.createElement('canvas');
    cv.width = Math.round(sw * sc); cv.height = Math.round(sh * sc);
    cv.getContext('2d').drawImage(img, b.x * img.naturalWidth, b.y * img.naturalHeight, sw, sh, 0, 0, cv.width, cv.height);
    return { url: cv.toDataURL('image/jpeg', .9), ratio: sw / sh };
  }

  function init(root) {
    if (!document.getElementById('sa-wpa-css')) { var st = el('style'); st.id = 'sa-wpa-css'; st.textContent = CSS; document.head.appendChild(st); }
    var app = root.querySelector('[data-sa-wp-app]'); app.innerHTML = '';
    var state = { room: null, layout: LAYOUTS[0], size: 'XL', frame: 'canvas', mount: true, slots: [null], active: 0, known: 84, unit: 'in',
      ruler: { a: .25, b: .75, y: .72 }, pos: { x: .5, y: .38 }, products: [], filter: '', autoSize: true, showAll: false };

    var wrap = el('div', 'sa-wpa');
    var stage = el('div', 'sa-wpa__stage');
    var panel = el('div', 'sa-wpa__panel');
    wrap.appendChild(stage); wrap.appendChild(panel); app.appendChild(wrap);

    /* ---------- stage ---------- */
    var file = el('input'); file.type = 'file'; file.accept = 'image/*'; file.style.display = 'none'; app.appendChild(file);
    var empty = el('div', 'sa-wpa__empty',
      '<button type="button" class="btn btn--filled sa-wpa__up" data-up>Upload a photo of your wall</button>' +
      (root.getAttribute('data-sample') ? '<button type="button" class="sa-wpa__link" data-sample>No photo? Try a sample room</button>' : '') +
      '<p class="sa-wpa__tipline">Stand back, hold your phone straight and include your sofa, bed or a door.</p>' +
      '<span class="sa-wpa__privacy">Your photo stays on your device. It is not sent to us.</span>');
    stage.appendChild(empty);
    var roomImg = el('img', 'sa-wpa__room'); roomImg.alt = 'Your wall'; roomImg.style.display = 'none'; stage.appendChild(roomImg);
    var layer = el('div', 'sa-wpa__layer'); stage.appendChild(layer);
    var tip = el('div', 'sa-wpa__tip'); tip.style.display = 'none'; stage.appendChild(tip);
    var group = el('div', 'sa-wpa__group'); layer.appendChild(group);
    var ruler = el('div', 'sa-wpa__ruler'), d1 = el('div', 'sa-wpa__dot'), d2 = el('div', 'sa-wpa__dot'), rl = el('div', 'sa-wpa__rlabel');
    layer.appendChild(ruler); layer.appendChild(d1); layer.appendChild(d2); layer.appendChild(rl);
    [ruler, d1, d2, rl, group].forEach(function (n) { n.style.display = 'none'; });

    empty.querySelector('[data-up]').addEventListener('click', function () { file.click(); });
    var sb = empty.querySelector('[data-sample]');
    if (sb) sb.addEventListener('click', function () { setRoom(root.getAttribute('data-sample'), 'sofa'); });
    file.addEventListener('change', function () { var f = file.files && file.files[0]; if (f) setRoom(URL.createObjectURL(f)); });

    function setRoom(src, obj) {
      roomImg.onload = function () {
        empty.style.display = 'none'; roomImg.style.display = 'block'; stage.classList.add('has-room'); stickTop();
        [ruler, d1, d2, rl, group].forEach(function (n) { n.style.display = ''; });
        state.room = roomImg; state.moved = false;
        if (obj) setObj(obj);
        render(); showTip();
      };
      roomImg.src = src;
    }
    function showTip() {
      if (!state.room || state.moved) { tip.style.display = 'none'; return; }
      tip.style.display = ''; tip.innerHTML = 'Drag the <b>orange dots</b> to each end of your ' + objName() + '.';
    }

    /* ---------- panel ---------- */
    function step(n, title, help) {
      var s = el('div', 'sa-wpa__step');
      s.innerHTML = '<div class="sa-wpa__sh"><span>' + n + '</span><h3>' + title + '</h3></div>' + (help ? '<p class="sa-wpa__help">' + help + '</p>' : '');
      panel.appendChild(s); return s;
    }

    /* Step 1: set the scale with something the customer knows the width of */
    var OBJS = [ { k: 'sofa', label: 'Sofa', w: 84 }, { k: 'bed', label: 'Bed', w: 60 }, { k: 'door', label: 'Door', w: 32 }, { k: 'other', label: 'Something else', w: 0 } ];
    function objName() { return state.obj === 'other' ? 'the item you know the width of' : state.obj; }
    var s1 = step(1, '', '');
    var s1h = s1.querySelector('h3');
    s1.appendChild(el('p', 'sa-wpa__label', 'What did you mark?'));
    var orow = el('div', 'sa-wpa__row'); s1.appendChild(orow);
    OBJS.forEach(function (o) {
      var b = el('button', 'sa-wpa__chip', o.label + (o.w ? '<small>about ' + o.w + '" / ' + Math.round(o.w * 2.54) + ' cm</small>' : '<small>type the width</small>')); b.type = 'button'; b.setAttribute('data-o', o.k);
      b.addEventListener('click', function () { setObj(o.k); render(); showTip(); if (o.k === 'other') knownInput.focus(); });
      orow.appendChild(b);
    });
    var mrow = el('div', 'sa-wpa__row sa-wpa__other'); s1.appendChild(mrow);
    var knownInput = el('input', 'sa-wpa__num'); knownInput.type = 'number'; knownInput.min = '5'; knownInput.inputMode = 'decimal'; knownInput.setAttribute('aria-label', 'Width of the marked item');
    var unitSel = el('select', 'sa-wpa__sel', '<option value="in">inches</option><option value="cm">cm</option>');
    mrow.appendChild(el('span', '', 'Its width:')); mrow.appendChild(knownInput); mrow.appendChild(unitSel);
    s1.appendChild(el('p', 'sa-wpa__help', 'The photo can\'t measure by itself, so the art is sized from this width. Measure your sofa, bed or door and change the number if it isn\'t the usual size.'));
    var change = el('button', 'sa-wpa__link', 'Change photo'); change.type = 'button'; s1.appendChild(change);
    knownInput.addEventListener('input', function () { var v = parseFloat(knownInput.value); if (v > 0) { state.known = state.unit === 'cm' ? v / 2.54 : v; render(); } });
    unitSel.addEventListener('change', function () { state.unit = unitSel.value; knownInput.value = state.unit === 'cm' ? Math.round(state.known * 2.54) : Math.round(state.known); render(); });
    change.addEventListener('click', function () { file.click(); });
    function setObj(k) {
      state.obj = k; var o = OBJS.filter(function (x) { return x.k === k; })[0];
      if (o.w) state.known = o.w;
      knownInput.value = state.unit === 'cm' ? Math.round(state.known * 2.54) : Math.round(state.known);
      s1h.innerHTML = 'Drag the 2 orange dots to each end of your ' + objName();
      orow.querySelectorAll('[data-o]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-o') === k); });
    }
    state.obj = 'sofa';

    /* Step 2: the look and the finish (always visible, so canvas and framed can be compared) */
    var s2 = step(2, 'Choose the look');
    var lrow = el('div', 'sa-wpa__row'); s2.appendChild(lrow);
    LAYOUTS.forEach(function (L) {
      var b = el('button', 'sa-wpa__chip', L.label); b.type = 'button'; b.setAttribute('data-l', L.k);
      b.addEventListener('click', function () { state.layout = L; if (!state.autoSize) state.size = L.size; var old = state.slots; state.slots = []; for (var i = 0; i < L.n; i++) state.slots.push(old[i] || old[0] || null); state.active = 0; render(); });
      lrow.appendChild(b);
    });
    var fitNote = el('p', 'sa-wpa__fit'); s2.appendChild(fitNote);
    var flab = el('p', 'sa-wpa__label', '<b>Finish</b>'); flab.style.marginTop = '14px'; s2.appendChild(flab);
    var frow = el('div', 'sa-wpa__row'); s2.appendChild(frow);
    var styleCanvas = el('button', 'sa-wpa__chip', 'Canvas or Poster'); styleCanvas.type = 'button';
    var styleFrame = el('button', 'sa-wpa__chip', 'Framed Poster'); styleFrame.type = 'button';
    frow.appendChild(styleCanvas); frow.appendChild(styleFrame);
    var swrow = el('div', 'sa-wpa__row'); swrow.style.marginTop = '10px'; s2.appendChild(swrow);
    ['black', 'white', 'wood', 'gold', 'silver'].forEach(function (c) {
      var b = el('button', 'sa-wpa__sw'); b.type = 'button'; b.title = c; b.setAttribute('aria-label', c + ' frame'); b.style.background = FRAMES[c]; b.setAttribute('data-c', c);
      b.addEventListener('click', function () { state.frame = c; render(); });
      swrow.appendChild(b);
    });
    styleCanvas.addEventListener('click', function () { state.frame = 'canvas'; render(); });
    styleFrame.addEventListener('click', function () { if (state.frame === 'canvas') state.frame = 'black'; render(); });

    var s5 = step(3, 'Choose the art', 'For more than one piece, tap a spot first, then a painting.');
    var slotRow = el('div', 'sa-wpa__slots'); s5.appendChild(slotRow);
    var search = el('input', 'sa-wpa__search'); search.type = 'search'; search.placeholder = 'Search, e.g. Ayatul Kursi'; s5.appendChild(search);
    var list = el('div', 'sa-wpa__list', '<p style="grid-column:1/-1;font-size:13px;opacity:.7">Loading paintings…</p>'); s5.appendChild(list);
    search.addEventListener('input', function () { state.filter = search.value.toLowerCase().replace(/[^a-z0-9]/g, ''); drawList(); });

    /* Size is optional: we suggest a size that fits; customers who know what they want can open this */
    var opt = el('details', 'sa-wpa__opt'); panel.appendChild(opt);
    opt.appendChild(el('summary', '', '<span>Know the size you want? <u>Choose it here</u></span>'));
    var s3 = el('div', 'sa-wpa__optin'); opt.appendChild(s3);
    s3.appendChild(el('p', 'sa-wpa__label', '<b>Size</b> (each piece)'));
    var zrow = el('div', 'sa-wpa__row'); s3.appendChild(zrow);
    var autoB = el('button', 'sa-wpa__chip', 'Best fit<small>we choose</small>'); autoB.type = 'button'; autoB.setAttribute('data-z', 'auto'); zrow.appendChild(autoB);
    autoB.addEventListener('click', function () { state.autoSize = true; render(); });
    SIZES.forEach(function (z) {
      var b = el('button', 'sa-wpa__chip', z.k + '<small>' + z.w + 'x' + z.h + '"</small>'); b.type = 'button'; b.setAttribute('data-z', z.k);
      b.addEventListener('click', function () { state.autoSize = false; state.size = z.k; render(); });
      zrow.appendChild(b);
    });

    var s6 = step(4, 'Save your picture');
    var act = el('div', 'sa-wpa__actions'); s6.appendChild(act);
    var save = el('button', 'btn btn--filled', 'Save picture'); save.type = 'button'; act.appendChild(save);
    var shop = el('ul', 'sa-wpa__shop'); s6.appendChild(shop);
    s6.appendChild(el('p', 'sa-wpa__help', 'It saves to your phone, so you can share it with family.'));
    setObj('sofa');

    /* ---------- catalogue ---------- */
    var coll = root.getAttribute('data-coll') || '/collections/view-all';
    function fetchPage(p) { return fetch(coll + '/products.json?limit=250&page=' + p).then(function (r) { return r.json(); }).then(function (j) { return j.products || []; }); }
    Promise.all([fetchPage(1), fetchPage(2)]).then(function (pages) {
      var seen = {};
      pages[0].concat(pages[1]).forEach(function (p) {
        var h = p.handle.toLowerCase(), t = (p.product_type || '').toLowerCase();
        if (seen[h] || t === 'original' || /gift-card|bundle|-set|pair|levels|digital|download/.test(h) || !p.images || !p.images.length) return;
        seen[h] = 1;
        state.products.push({ handle: p.handle, title: p.title.split('|')[0].trim(), hay: (p.title + ' ' + (p.tags || []).join(' ')).toLowerCase().replace(/[^a-z0-9]/g, ''), img: p.images[0].src, art: null });
      });
      drawList();
      var want = (location.search.match(/[?&]art=([^&]+)/) || [])[1];
      var first = want && state.products.filter(function (p) { return p.handle === decodeURIComponent(want); })[0];
      pick(first || state.products[0]);
    }).catch(function () { list.innerHTML = '<p style="grid-column:1/-1;font-size:13px">Could not load the paintings. Please refresh the page.</p>'; });

    function drawList() {
      list.innerHTML = '';
      var all = state.products.filter(function (p) { return !state.filter || p.hay.indexOf(state.filter) > -1; }).slice(0, 120);
      var shown = (isPhone() && !state.showAll && !state.filter) ? all.slice(0, MOBILE_LIST) : all;
      shown.forEach(function (p) {
        var b = el('button', 'sa-wpa__art'); b.type = 'button'; b.title = p.title; b.setAttribute('aria-label', p.title);
        var cur = state.slots[state.active]; if (cur && cur.handle === p.handle) b.classList.add('is-on');
        var t = el('span', 't'); b.appendChild(t);
        var im = el('img'); im.loading = 'lazy'; im.alt = '';
        if (p.thumb) im.src = p.thumb;
        else { im.onload = function () { im.onload = null; try { var a = artFrom(im, 300); p.thumb = a.url; im.src = a.url; } catch (e) {} }; im.src = sized(p.img, 360); }
        t.appendChild(im); b.appendChild(el('span', 'n', p.title));
        b.addEventListener('click', function () { pick(p, true); });
        list.appendChild(b);
      });
      if (shown.length < all.length) {
        var more = el('button', 'sa-wpa__more', 'Show more paintings (' + (all.length - shown.length) + ')'); more.type = 'button';
        more.addEventListener('click', function () { state.showAll = true; drawList(); });
        list.appendChild(more);
      }
    }
    function pick(p, user) {
      if (!p) return;
      var slot = state.active;
      var done = function () {
        state.slots[slot] = p;
        if (state.active < state.slots.length - 1 && slot === state.active) {
          for (var i = 0; i < state.slots.length; i++) if (!state.slots[i]) { state.slots[i] = p; }
        }
        if (state.slots.length > 1 && slot === state.active && user) state.active = (slot + 1) % state.slots.length;
        render(); drawList();
      };
      if (p.art) return done();
      load(sized(p.img, 1200)).then(function (img) { p.art = artFrom(img); done(); }).catch(function () { p.art = { url: sized(p.img, 900), ratio: 1 }; done(); });
    }

    /* ---------- geometry ---------- */
    function dims(p) { /* size of one piece in inches, following the painting's shape */
      var z = SIZES.filter(function (s) { return s.k === state.size; })[0];
      var portrait = p && p.art ? p.art.ratio < 0.95 : false;
      return portrait ? { w: z.w, h: z.h } : { w: z.h, h: z.w };
    }
    function layoutBoxes() { /* positions in inches relative to the group's centre */
      var L = state.layout, n = L.n, boxes = [], i;
      var d = []; for (i = 0; i < n; i++) d.push(dims(state.slots[i] || state.slots[0]));
      var cols = L.cols, rows = Math.ceil(n / cols), colW = [], rowH = [];
      for (i = 0; i < n; i++) { var c = i % cols, r = Math.floor(i / cols); colW[c] = Math.max(colW[c] || 0, d[i].w); rowH[r] = Math.max(rowH[r] || 0, d[i].h); }
      var totW = colW.reduce(function (a, b) { return a + b; }, 0) + GAP * (cols - 1), totH = rowH.reduce(function (a, b) { return a + b; }, 0) + GAP * (rows - 1);
      for (i = 0; i < n; i++) {
        var cc = i % cols, rr = Math.floor(i / cols), x = -totW / 2, y = -totH / 2, k;
        for (k = 0; k < cc; k++) x += colW[k] + GAP; for (k = 0; k < rr; k++) y += rowH[k] + GAP;
        x += (colW[cc] - d[i].w) / 2; y += (rowH[rr] - d[i].h) / 2;
        boxes.push({ x: x, y: y, w: d[i].w, h: d[i].h });
      }
      return { boxes: boxes, w: totW, h: totH };
    }
    function pxPerIn() {
      var W = roomImg.clientWidth; var len = Math.abs(state.ruler.b - state.ruler.a) * W;
      return len / Math.max(1, state.known);
    }

    /* ---------- render ---------- */
    function bestSize() { /* largest size whose group fits within about 2/3 of the marked width */
      var keep = state.size, pick = SIZES[0].k, lim = state.known * 0.68;
      for (var i = 0; i < SIZES.length; i++) { state.size = SIZES[i].k; if (layoutBoxes().w <= lim) pick = SIZES[i].k; }
      state.size = keep; return pick;
    }
    function render() {
      if (state.autoSize) state.size = bestSize();
      var zz = SIZES.filter(function (x) { return x.k === state.size; })[0];
      fitNote.innerHTML = (state.autoSize ? 'Suggested size: ' : 'Your size: ') + '<b>' + zz.k + ' ' + zz.w + 'x' + zz.h + '"</b>' + (state.slots.length > 1 ? ' each' : '') + (state.autoSize && state.room ? ', to fit your ' + (state.obj === 'other' ? 'wall' : state.obj) : '');
      lrow.querySelectorAll('[data-l]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-l') === state.layout.k); });
      zrow.querySelectorAll('[data-z]').forEach(function (b) { b.classList.toggle('is-on', state.autoSize ? b.getAttribute('data-z') === 'auto' : b.getAttribute('data-z') === state.size); });
      styleCanvas.classList.toggle('is-on', state.frame === 'canvas'); styleFrame.classList.toggle('is-on', state.frame !== 'canvas');
      swrow.style.display = state.frame === 'canvas' ? 'none' : '';
      swrow.querySelectorAll('[data-c]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-c') === state.frame); });
      /* slots */
      slotRow.innerHTML = '';
      if (state.slots.length > 1) state.slots.forEach(function (p, i) {
        var b = el('button', 'sa-wpa__chip' + (i === state.active ? ' is-on' : ''), 'Spot ' + (i + 1) + (p ? '<small>' + p.title + '</small>' : '')); b.type = 'button';
        b.addEventListener('click', function () { state.active = i; render(); drawList(); });
        slotRow.appendChild(b);
      });
      /* shop links */
      shop.innerHTML = ''; var seen = {};
      state.slots.forEach(function (p) { if (p && !seen[p.handle]) { seen[p.handle] = 1; shop.appendChild(el('li', '', '<a href="/products/' + p.handle + '">Shop ' + p.title + ' &rarr;</a> <span style="opacity:.6">' + state.size + ', ' + (state.frame === 'canvas' ? 'canvas or poster' : 'framed poster') + '</span>')); } });
      if (!state.room) return;
      var W = roomImg.clientWidth, H = roomImg.clientHeight, ox = roomImg.offsetLeft, oy = roomImg.offsetTop;
      /* ruler */
      var ax = ox + state.ruler.a * W, bx = ox + state.ruler.b * W, ry = oy + state.ruler.y * H;
      ruler.style.left = Math.min(ax, bx) + 'px'; ruler.style.width = Math.abs(bx - ax) + 'px'; ruler.style.top = ry + 'px';
      d1.style.left = ax + 'px'; d1.style.top = ry + 'px'; d2.style.left = bx + 'px'; d2.style.top = ry + 'px';
      rl.style.left = (ax + bx) / 2 + 'px'; rl.style.top = ry + 'px';
      rl.textContent = (state.obj === 'other' ? '' : state.obj.charAt(0).toUpperCase() + state.obj.slice(1) + ' · ') + (state.unit === 'cm' ? Math.round(state.known * 2.54) + ' cm' : Math.round(state.known) + '"');
      /* art */
      var k = pxPerIn(), lay = layoutBoxes();
      group.style.width = lay.w * k + 'px'; group.style.height = lay.h * k + 'px';
      group.style.left = (ox + state.pos.x * W - lay.w * k / 2) + 'px'; group.style.top = (oy + state.pos.y * H - lay.h * k / 2) + 'px';
      group.innerHTML = '';
      lay.boxes.forEach(function (b, i) {
        var p = state.slots[i], piece = el('div', 'sa-wpa__piece' + (state.frame === 'canvas' ? ' is-canvas' : '') + (state.slots.length > 1 && i === state.active ? ' is-active' : ''));
        piece.style.left = (b.x + lay.w / 2) * k + 'px'; piece.style.top = (b.y + lay.h / 2) * k + 'px'; piece.style.width = b.w * k + 'px'; piece.style.height = b.h * k + 'px';
        var inner = piece;
        if (state.frame !== 'canvas') {
          var fw = Math.max(1, 1.1 * k), mw = Math.min(b.w, b.h) * 0.1 * k;
          piece.style.border = fw + 'px solid ' + FRAMES[state.frame];
          piece.style.background = '#fff';
          inner = el('div', 'm'); inner.style.cssText = 'position:absolute;left:' + mw + 'px;top:' + mw + 'px;right:' + mw + 'px;bottom:' + mw + 'px;overflow:hidden;background:#eee;box-shadow:inset 0 0 2px rgba(0,0,0,.25)';
          piece.appendChild(inner);
        }
        if (p && p.art) { var im = el('img'); im.alt = p.title; im.src = p.art.url; inner.appendChild(im); }
        else inner.appendChild(el('div', 'ph', 'Choose a painting'));
        piece.addEventListener('pointerdown', function () { if (state.slots.length > 1 && state.active !== i) { state.active = i; slotRow.querySelectorAll('.sa-wpa__chip').forEach(function (c, j) { c.classList.toggle('is-on', j === i); }); drawList(); } });
        group.appendChild(piece);
      });
    }
    function stickTop() { /* keep the preview in view under the sticky header while the options are changed */
      var top = 16;
      document.querySelectorAll('.sticky-header, .shopify-section-group-header-group, .site-header').forEach(function (h) {
        var p = getComputedStyle(h).position;
        if (p === 'sticky' || p === 'fixed') top = Math.max(top, h.getBoundingClientRect().height + 8);
      });
      stage.style.setProperty('--sa-wp-top', top + 'px');
    }
    var lastPhone = isPhone();
    window.addEventListener('resize', function () { stickTop(); render(); if (isPhone() !== lastPhone) { lastPhone = isPhone(); drawList(); } });

    /* ---------- dragging ---------- */
    function drag(node, onMove) {
      node.addEventListener('pointerdown', function (e) {
        e.preventDefault(); node.setPointerCapture(e.pointerId);
        var r = roomImg.getBoundingClientRect(), last = { x: e.clientX, y: e.clientY };
        function mv(ev) { onMove((ev.clientX - last.x) / r.width, (ev.clientY - last.y) / r.height, (ev.clientX - r.left) / r.width, (ev.clientY - r.top) / r.height); last = { x: ev.clientX, y: ev.clientY }; render(); }
        function up() { node.removeEventListener('pointermove', mv); node.removeEventListener('pointerup', up); node.removeEventListener('pointercancel', up); }
        node.addEventListener('pointermove', mv); node.addEventListener('pointerup', up); node.addEventListener('pointercancel', up);
      });
    }
    function clamp(v) { return Math.max(0, Math.min(1, v)); }
    drag(group, function (dx, dy) { state.pos.x = clamp(state.pos.x + dx); state.pos.y = clamp(state.pos.y + dy); });
    drag(d1, function (dx, dy, x, y) { state.ruler.a = clamp(x); state.ruler.y = clamp(y); state.moved = true; tip.style.display = 'none'; });
    drag(d2, function (dx, dy, x, y) { state.ruler.b = clamp(x); state.ruler.y = clamp(y); state.moved = true; tip.style.display = 'none'; });

    /* ---------- save ---------- */
    save.addEventListener('click', function () {
      if (!state.room) { file.click(); return; }
      var nat = roomImg.naturalWidth / roomImg.clientWidth, cv = document.createElement('canvas');
      cv.width = roomImg.naturalWidth; cv.height = roomImg.naturalHeight;
      var g = cv.getContext('2d'); g.drawImage(roomImg, 0, 0);
      var gx = (parseFloat(group.style.left) - roomImg.offsetLeft) * nat, gy = (parseFloat(group.style.top) - roomImg.offsetTop) * nat;
      var pieces = group.querySelectorAll('.sa-wpa__piece'), jobs = [];
      pieces.forEach(function (pc) {
        var x = gx + parseFloat(pc.style.left) * nat, y = gy + parseFloat(pc.style.top) * nat, w = parseFloat(pc.style.width) * nat, h = parseFloat(pc.style.height) * nat;
        var im = pc.querySelector('img');
        g.save(); g.shadowColor = 'rgba(0,0,0,.3)'; g.shadowBlur = 14 * nat; g.shadowOffsetX = 3 * nat; g.shadowOffsetY = 6 * nat;
        g.fillStyle = state.frame === 'canvas' ? '#ddd' : FRAMES[state.frame]; g.fillRect(x, y, w, h); g.restore();
        var ax = x, ay = y, aw = w, ah = h;
        if (state.frame !== 'canvas') {
          var fw = parseFloat(pc.style.borderLeftWidth) * nat; g.fillStyle = '#fff'; g.fillRect(x + fw, y + fw, w - 2 * fw, h - 2 * fw);
          var m = pc.querySelector('.m'); var mw = parseFloat(m.style.left) * nat; ax = x + fw + mw; ay = y + fw + mw; aw = w - 2 * (fw + mw); ah = h - 2 * (fw + mw);
        }
        if (im) jobs.push(load(im.src).then(function (ai) {
          var r = aw / ah, sr = ai.naturalWidth / ai.naturalHeight, sx = 0, sy = 0, sw = ai.naturalWidth, sh = ai.naturalHeight;
          if (sr > r) { sw = sh * r; sx = (ai.naturalWidth - sw) / 2; } else { sh = sw / r; sy = (ai.naturalHeight - sh) / 2; }
          g.drawImage(ai, sx, sy, sw, sh, ax, ay, aw, ah);
        }));
      });
      Promise.all(jobs).then(function () {
        cv.toBlob(function (blob) {
          var f = new File([blob], 'my-wall-saleha-art.jpg', { type: 'image/jpeg' });
          if (navigator.canShare && navigator.canShare({ files: [f] })) { navigator.share({ files: [f], title: 'My wall with Saleha Art' }).catch(function () {}); return; }
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'my-wall-saleha-art.jpg'; document.body.appendChild(a); a.click(); a.remove();
        }, 'image/jpeg', .9);
      });
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-sa-wp]').forEach(function (r) { if (!r.__saWp) { r.__saWp = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
